module.exports = function( THREE ){

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	THREE.TexturePass = function ( texture, opacity ) {

		if ( THREE.CopyShader === undefined )
			console.error( "THREE.TexturePass relies on THREE.CopyShader" );

		var shader = THREE.CopyShader;

		this.uniforms = THREE.UniformsUtils.clone( shader.uniforms );

		this.uniforms[ "opacity" ].value = ( opacity !== undefined ) ? opacity : 1.0;
		this.uniforms[ "tDiffuse" ].value = texture;

		this.material = new THREE.ShaderMaterial( {

			uniforms: this.uniforms,
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader

		} );

		this.enabled = true;
		this.needsSwap = false;


		this.camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
		this.scene  = new THREE.Scene();

		this.quad = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2, 2 ), null );
		this.scene.add( this.quad );

	};

	THREE.TexturePass.prototype = {

		render: function ( renderer, writeBuffer, readBuffer, delta ) {

			this.quad.material = this.material;

			renderer.render( this.scene, this.camera, readBuffer );

		}

	};

};


//////////////////
// WEBPACK FOOTER
// ./~/three-js/addons/TexturePass.js
// module id = 454
// module chunks = 0